import { FC, useCallback, useLayoutEffect, useState } from "react";
import { useContext } from "use-context-selector";
import styled from "styled-components";
import VideoChat from "./VideoChat";
import { ExternalContext } from "../context/ExternalContext";
import { useVideoChat } from "../hooks/useVideoChat";
import { useInfo } from "../hooks/useInfo";
import { authenticate } from "../api/rooms/authenticate";
import HelpModal from "../components/Modals/HelpModal";
import AppHeader from "../components/AppHeader/AppHeader";
import useQuery from "../utils/useQuery";

const VideoAppContainer = styled("div")`
  height: 100%;
  display: flex;
  flex-flow: column;
`;

const VideoAppContent = styled("div")`
  height: 100%;
  min-height: 0;
`;

const ActionMessage = styled("div")`
  display: flex;
  align-items: center;
  height: 100%;
  color: #ffffff;
  font-size: 22px;
  span {
    width: 100%;
    padding: 16px 0;
    letter-spacing: 0.08rem;
    text-align: center;
    background: rgba(187, 187, 187, 0.068);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(2.5px);
    -webkit-backdrop-filter: blur(2.5px);
  }
`;

const VideoApp: FC = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [ready, setReady] = useState<boolean>(false);
  const [actionMessage, setActionMessage] = useState<string>("");

  const { permission, handleSetPermission } = useVideoChat();
  const { handleSetTelemedicineData } = useInfo();

  const handleChangeActionMessage = (message: string) => {
    setActionMessage(message);
  };

  // Define as informações básicas do paciente e do médico
  useLayoutEffect(() => {
    const telemedicineToken = useQuery().get("token");

    if (telemedicineToken) {
      authenticate(
        useQuery().get("token") || "",
        handleChangeActionMessage
      ).then((response) => {
        if (response) {
          handleSetPermission(response.data.permission);
          handleSetTelemedicineData(response.data);
          setReady(true);
        }
      });

      setActionMessage("Buscando token de acesso...");
    } else {
      setActionMessage("Link para teleatendimento inválido");
    }
  }, []);

  const handleClose = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleOpen = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  // Verifica se o usuário é paciente e então renderiza a página inicial
  const page = (): JSX.Element => {
    return <VideoChat />;
  };

  return (
    <VideoAppContainer>
      <AppHeader handleOpen={handleOpen} />
      <VideoAppContent>
        {ready ? (
          page()
        ) : (
          <ActionMessage>
            <span>{actionMessage}</span>
          </ActionMessage>
        )}
      </VideoAppContent>
      <HelpModal opened={isModalOpen} handleClose={handleClose} />
    </VideoAppContainer>
  );
};

export default VideoApp;
